import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import Joi from "joi";
import { useSelectedTheme, useTranslate } from "../../../../../../../Hooks";
import {
  CustomAutocomplete,
  CustomBadge,
  CustomButton,
  CustomDatePickerComponent,
  CustomDialog,
  CustomSelect,
  CustomSwitch,
  CustomTextArea,
  DropzoneComponent,
} from "../../../../../../../Components";
import { Box, Divider, Table, Typography } from "@material-ui/core";
import clsx from "clsx";
import {
  getDownloadableLink,
  getErrorByName,
} from "../../../../../../../Helper";
import { ActivityRelatedToInput } from "../ActivityRelatedToInput/ActivityRelatedToInput";
import {
  contactsDetailsGet,
  CreateActivity,
  leadDetailsGet,
} from "../../../../../../../Services";
import {
  Calendar,
  ClockIcon,
  DeleteIcon,
  DropdownIcon,
  EditIcon,
  PlusIcon,
} from "../../../../../../../assets/icons";
import { ReminderTypeOptionsComponent } from "../../../../../../../Components/V2/Header/UI/ReminderTypeOptionsComponent";
import { useVerticalNav } from "../../../../../../../Contexts/VerticalNavContext";

// Styles
import useStyles from "./styles";

function ReplayActivityFormDialog({
  isOpen,
  onClose,
  state,
  setState,
  selected,
  setSelected,
  data,
  setData,
  isGeneralDialog,
  categoryName,
  activeItem,
  activityRelatedToList,
  setIsRelatedToNotSelected,
  isWithReminder,
  withDateTime,
  loadings,
  setLoadings,
  close,
}) {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { setAlertBoxContent } = useVerticalNav();
  const { translate } = useTranslate("NewContactsView");
  const userInfo = JSON.parse(localStorage.getItem("session"));
  const [LeadId, setLeadId] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedReminderForWhom, setSelectedReminderForWhom] = useState("");
  const [activityAssignToOptions, setActivityAssignToOptions] = useState([]);
  const [uploadedFileId, setUploadedFileId] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const checkIsRelatedLeadClosed = () => {
    const relatedLeadStatus =
      selected?.relatedLead?.lead?.status?.lookupItemName;
    return activeItem?.relatedLeadNumberId && relatedLeadStatus === "Closed";
  };

  const onConfirmHandler = () => {};
  const reminderAmountOfTimeTypes = [
    { key: 1, value: "minutes", momentKey: "minutes" },
    { key: 2, value: "hours", momentKey: "hours" },
    { key: 3, value: "days", momentKey: "days" },
  ];

  const creatorInfo = {
    id: userInfo?.userId,
    value: userInfo?.fullName,
    type: "creator",
  };

  const handleDeleteLink = (ItemToDelete) => {
    const updatedReminders = state.activityReminders.filter(
      (_, i) => i !== ItemToDelete
    );
    setState({
      id: "activityReminders",
      value: updatedReminders,
    });
  };

  const handleEditLink = (ItemToEdit) => {};

  const handleExpandMoreOptions = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleFilesAccepted = (files) => {
    setUploadedFiles(files);
  };

  const formatUploadedDocumentToMapp = () => {
    if (uploadedFileId) {
      setState({
        id: "files",
        value: [
          {
            uuid: uploadedFileId,
            fileName: uploadedFiles[0].name,
            url: null,
            isUploaded: true,
            fileId: uploadedFileId,
          },
        ],
      });
    } else {
      return;
    }
  };

  const formattedTimeFun = (dateString) => {
    const formattedTime = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(dateString);
    return formattedTime;
  };

  const getTimeValue = (item) => {
    if (!state.activityDate) return 0;
    const currentTimeAmountType = reminderAmountOfTimeTypes.find(
      (items) => items.key === (item.reminderAmountOfTimeType || 1)
    );
    return moment(state.activityDate).diff(
      item.reminderTime,
      currentTimeAmountType.momentKey
    );
  };

  const getRelatedLeadDetails = useCallback(
    async (leadId) => {
      setLoadings({ id: "relatedLead", value: true });
      const res = await leadDetailsGet({ id: leadId });
      if (!(res && res.status && res.status !== 200)) {
        setSelected({ id: "relatedLead", value: res });
        if (selected.activityAssign) {
          const reminderForOptions = [
            {
              id: selected.activityAssign?.id,
              value: selected.activityAssign?.fullName,
              type: "agent",
            },
            {
              id: res.leadId,
              value: res?.lead?.contact_name?.name,
              type: "lead",
            },
          ];
          setSelected({ id: "reminderForOptions", value: reminderForOptions });
        }
      }
      setLoadings({ id: "relatedLead", value: false });
    },
    [selected.activityAssign]
  );
  const handleAddRemenders = () => {
    setState({
      id: "activityReminders",
      value: [
        {
          reminderType: null,
          templateId: null,
          leadId: null,
          usersId: null,
          reminderTime: "",
          reminderAmountOfTimeType: 1,
        },
        ...state.activityReminders,
      ],
    });

    setSelected({
      id: "activityReminders",
      value: [
        {
          templete: [],
          ReminderforWhom: [],
          reminderType: null,
        },
        ...selected.activityReminders,
      ],
    });
    setSelectedReminderForWhom(1);
  };

  const getContactDetails = useCallback(async (contactId) => {
    setLoadings({ id: "relatedContact", value: true });
    const res = await contactsDetailsGet({ id: contactId });
    if (!(res && res.status && res.status !== 200)) {
      setSelected({ id: "relatedContact", value: res });
    } else {
      setSelected({ id: "relatedContact", value: null });
    }
    setLoadings({ id: "relatedContact", value: false });
  }, []);

  const reminderTimeCalculateHandler = useCallback(
    (item, value, type, activityDate) => {
      const currentTimeAmountType = reminderAmountOfTimeTypes.find(
        (items) => items.key === (type || item.reminderAmountOfTimeType || 1)
      );
      let newTimeValue = moment(activityDate || state.activityDate)
        .add(-value, currentTimeAmountType.momentKey)
        .format("YYYY-MM-DDTHH:mm:ss");
      if (
        moment(newTimeValue).isBefore(moment().format("YYYY-MM-DDTHH:mm:ss"))
      ) {
        newTimeValue = null;
      }
      setState({ id: "activityReminders", value: state.activityReminders });
      return newTimeValue;
    },
    [reminderAmountOfTimeTypes, state.activityDate, state.activityReminders]
  );

  const activityTimeChangeHandler = (activityDate) => {
    if (state.activityReminders) {
      const mappedActiveItemReminders = state.activityReminders.map((item) => ({
        ...item,
        reminderTime: reminderTimeCalculateHandler(
          item,
          getTimeValue(item) || 0,
          item.reminderAmountOfTimeType,
          activityDate
        ),
      }));
      setState({ id: "activityReminders", value: mappedActiveItemReminders });
    }
  };
  const saveHandler = async (event) => {
    try {
      setIsSubmitted(true);
      const saveState = { ...state };
      const filteredReminders = saveState.activityReminders.filter(
        (item) =>
          (item.usersId || item.leadId) &&
          item.reminderType &&
          item.templateId &&
          item.reminderTime
      );
      const mappedReminders = filteredReminders.map((item) => {
        const contactId = item.leadId
          ? selected.relatedLead?.lead?.contact_name?.id
          : null;
        return {
          activityReminderId: item.activityReminderId,
          reminderType: item.reminderType,
          reminderTime: item.reminderTime,
          templateId: item.templateId,
          usersId: item.usersId,
          contactId,
        };
      });
      saveState.activityReminders = mappedReminders;

      setIsLoading(true);
      const res =
        activeItem &&
        activeItem.activityId &&
        (await CreateActivity(saveState));
      setIsLoading(false);
      if (!(res && res.status && res.status !== 200)) {
        setAlertBoxContent({
          display: true,
          variant: "success",
          title: translate("activity-Created-successfully"),
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
        close();
      } else {
        setAlertBoxContent({
          display: true,
          variant: "error",
          title: "Failed-to-created-activity",
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
      }
    } catch (error) {
      console.log("someThing error", error);
    } finally {
      setIsSubmitted(false);
    }
  };

  const schema = Joi.object({
    activityDate:
      (!activeItem &&
        ((withDateTime &&
          Joi.date()
            .required()
            .greater(Date.now())
            .messages({
              "date.base": translate(`activity-date-is-required`),
              "date.greater": translate(`choose-time-after-now`),
            })) ||
          Joi.any())) ||
      Joi.any(),
  })
    .options({
      abortEarly: false,
      allowUnknown: true,
    })
    .validate(state);

  useEffect(() => {
    if (activeItem && activeItem.relatedLeadNumberId) {
      getRelatedLeadDetails(activeItem.relatedLeadNumberId);
    }
  }, [activeItem, selected.activityAssign]);

  useEffect(() => {
    if (activeItem && activeItem.relatedContactNumberId) {
      getContactDetails(activeItem.relatedContactNumberId);
    }
  }, [activeItem]);

  useEffect(() => {
    if (activeItem) {
      const relatedUnit = activeItem.relatedUnitNumberId
        ? {
            id: activeItem.relatedUnitNumberId,
            propertyName: activeItem.relatedUnitPropertyName,
            unitRefNo: activeItem.unitReferenceNo,
          }
        : null;
      const relatedMaintenanceContract = activeItem.relatedMaintenanceContractId
        ? { maintenanceContractId: activeItem.relatedMaintenanceContractId }
        : null;
      const relatedPortfolio = activeItem.relatedPortfolioId
        ? {
            portfolioId: activeItem.relatedPortfolioId,
            portfolioName: activeItem.relatedPortfolioName,
          }
        : null;
      setSelected({
        id: "edit",
        value: {
          ...selected,
          relatedUnit,
          relatedPortfolio,
          relatedMaintenanceContract,
        },
      });
    }
  }, [activeItem]);

  useEffect(() => {
    var newActivityReminderFor = selected.reminderForOptions;

    const hasLead = newActivityReminderFor.some(
      (item) => item?.type === "lead"
    );

    if (!hasLead && selected.selected) {
      const relatedLead = {
        id: selected?.relatedLead?.leadId,
        value: selected?.relatedLead?.lead?.contact_name?.name,
        type: "lead",
      };

      newActivityReminderFor.push(relatedLead);
    }

    const hasCreator = newActivityReminderFor.some(
      (item) => item?.type === "creator"
    );

    if (!hasCreator) {
      newActivityReminderFor.push(creatorInfo);
    }

    newActivityReminderFor = newActivityReminderFor?.filter(
      (value, index, self) => index === self.findIndex((t) => t.id === value.id)
    );
    setActivityAssignToOptions(newActivityReminderFor || []);
  }, [selected.reminderForOptions]);

  useEffect(() => {
    formatUploadedDocumentToMapp();
  }, [uploadedFileId]);

  return (
    <>
      <CustomDialog
        open={isOpen}
        onClose={() => {
          onClose();
        }}
        title={translate("Add-Replay-Activity")}
        subtitle={translate(
          "Add-Replay-and-schedule-new-activity-to-enhance-engagement-with-your-contacts-and-leads"
        )}
        contentDialogClass={styles.containerContentDialog}
        width={"1024px"}
        isDisabled={checkIsRelatedLeadClosed()}
        cancelText={translate("cancle")}
        confirmText={translate("Save")}
        onConfirm={() => {
          saveHandler();
        }}
        content={
          <Box className={styles.wrapperAddNewActivityForm}>
            <Box className={styles.containerInfoActivitey}>
              {categoryName && (
                <Box className={styles.containerInfoItem}>
                  <Typography className={styles.containerInfoTitle}>
                    {translate("Category")}
                  </Typography>
                  <Typography className={styles.containerInfoValue}>
                    {categoryName}
                  </Typography>
                </Box>
              )}
              <Box className={styles.containerInfoItem}>
                <Typography className={styles.containerInfoTitle}>
                  {translate("activity-rating")}
                </Typography>
                {selected?.activityType &&
                selected?.activityType?.activityRateName ? (
                  <Typography className={styles.containerInfoValue}>
                    <CustomBadge
                      className={clsx(styles.positive_negative_Status, {
                        [styles.Natural]:
                          selected?.activityType?.activityRateName ===
                          "Neutral",
                        [styles.positiveSuperPositve]:
                          selected?.activityType?.activityRateName ===
                            "Positive" ||
                          selected?.activityType?.activityRateName ===
                            "SuperPositive",
                        [styles.negativeSuperNegative]:
                          selected?.activityType?.activityRateName ===
                            "Negative" ||
                          selected?.activityType?.activityRateName ===
                            "SuperNegative",
                      })}
                      label={
                        (selected?.activityType &&
                          selected?.activityType?.activityRateName) 
                      }
                      SizeVariant={"medium"}
                      BackgroundColor={
                        selected?.activityType?.activityRateName === "Neutral"
                          ? palette.utility.warning_50
                          : selected?.activityType?.activityRateName ===
                              "Positive" ||
                            selected?.activityType?.activityRateName ===
                              "SuperPositive"
                          ? palette.utility.success_50
                          : selected?.activityType?.activityRateName ===
                              "SuperNegative" ||
                            selected?.activityType?.activityRateName ===
                              "Negative"
                          ? palette.utility.error_50
                          : palette.utility.success_50
                      }
                      BorderColor={
                        selected?.activityType?.activityRateName === "Neutral"
                          ? palette.utility.warning_200
                          : selected?.activityType?.activityRateName ===
                              "SuperPositive" ||
                            selected?.activityType?.activityRateName ===
                              "Positive"
                          ? palette.utility.success_200
                          : selected?.activityType?.activityRateName ===
                              "Negative" ||
                            selected?.activityType?.activityRateName ===
                              "SuperNegative"
                          ? palette.utility.error_200
                          : palette.utility.success_200
                      }
                      Color={
                        selected?.activityType?.activityRateName === "Neutral"
                          ? palette.utility.warning_700
                          : selected?.activityType?.activityRateName ===
                              "SuperPositive" ||
                            selected?.activityType?.activityRateName ===
                              "Positive"
                          ? palette.utility.success_700
                          : selected?.activityType?.activityRateName ===
                              "Negative" ||
                            selected?.activityType?.activityRateName ===
                              "SuperNegative"
                          ? palette.utility.error_700
                          : palette.utility.success_700
                      }
                    ></CustomBadge>
                  </Typography>
                ) : (
                  <Typography className={styles.containerInfoTitle}>
                    N/A
                  </Typography>
                )}
              </Box>
              {selected?.activityType?.leadScore !== null ? (
                <Box className={styles.containerInfoItem}>
                  <Typography className={styles.containerInfoTitle}>
                    {translate("Lead-score")}
                  </Typography>
                  <Typography className={styles.containerInfoValue}>
                    <CustomBadge
                      className={clsx(styles.positive_negative_Status, {
                        [styles.positive]:
                          selected?.activityType?.leadScore >= 0,
                        [styles.negative]:
                          selected?.activityType?.leadScore < 0,
                      })}
                      label={
                        selected?.activityType?.leadScore > 0 ? (
                          <Box className={styles.plsColor}>
                            {`+${selected?.activityType?.leadScore}`}
                          </Box>
                        ) : selected?.activityType?.leadScore < 0 ? (
                          <Box className={styles.muinsColr}>
                            {`${selected?.activityType?.leadScore}`}
                          </Box>
                        ) : (
                          <Typography className={styles.containerInfoTitle}>
                            N/A
                          </Typography>
                        )
                      }
                      SizeVariant={"medium"}
                      BackgroundColor={
                        selected?.activityType?.leadScore >= 0
                          ? palette.utility.success_50
                          : palette.utility.error_50
                      }
                      BorderColor={
                        selected?.activityType?.leadScore >= 0
                          ? palette.utility.success_200
                          : palette.utility.error_200
                      }
                      Color={
                        selected?.activityType?.leadScore >= 0
                          ? palette.utility.success_700
                          : palette.utility.error_700
                      }
                    ></CustomBadge>
                  </Typography>
                </Box>
              ) : (
                <Typography className={styles.containerInfoTitle}>
                  N/A
                </Typography>
              )}

              <Box className={styles.containerInfoItem}>
                <Typography className={styles.containerInfoTitle}>
                  {translate("Created-by")}
                </Typography>
                <Box className={styles.containerCreatedBy}>
                  <Box className={styles.containerImage}>
                    <img
                      className={styles.ImageWrapper}
                      alt="HeaderPSITemplet"
                      src={
                        getDownloadableLink(selected.ImageCreatedByName) || null
                      }
                    />
                  </Box>
                  <Typography className={styles.containerInfoValue}>
                    {state.createdByName || ""}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box className={styles.containerfiledActivity}>
              <Box className={styles.containerInputFiled}>
                <Typography className={styles.titleInputFiled}>
                  {translate("Activity-name")}*
                </Typography>
                <CustomAutocomplete
                  isDisabled
                  placeholder={translate("Select")}
                  options={data?.activityTypes || []}
                  value={selected?.activityType || null}
                  getOptionLabel={(option) => option.activityTypeName || ""}
                  getOptionValue={(option) => option.id === state.assignAgentId}
                  renderOption={(option) => option.activityTypeName || ""}
                />
              </Box>
              <Divider />
              <Box className={styles.containerInputFiled}>
                <Typography className={styles.titleInputFiled}>
                  {translate("Activity-assign-to")}*
                </Typography>
                <CustomAutocomplete
                  variant={"avatar"}
                  avatarIdProp={selected.ImageCreatedByName || null}
                  isDisabled
                  options={data?.activityAssignments || []}
                  value={selected?.activityAssign || null}
                  getOptionLabel={(option) => option.fullName || ""}
                  getOptionValue={(option) => option.id === state.assignAgentId}
                  renderOption={(option) =>
                    ((option.userName || option.fullName) &&
                      `${option.fullName} (${option.userName})`) ||
                    ""
                  }
                />
              </Box>
              <Divider />
              <ActivityRelatedToInput
                activityRelatedToList={activityRelatedToList}
                setIsRelatedToNotSelected={setIsRelatedToNotSelected}
                isSubmitted={isSubmitted}
                isReplyDialog
                isWithReminder={isWithReminder}
                activeItem={activeItem}
                state={state}
                setState={setState}
                selected={selected}
                setSelected={setSelected}
                setLeadId={setLeadId}
                data={data}
                setData={setData}
                isGeneralDialog={isGeneralDialog}
                checkIsRelatedLeadClosed={checkIsRelatedLeadClosed}
              />
              {withDateTime && (
                <>
                  <Box className={styles.containerInputFiled}>
                    <Typography className={styles.titleInputFiled}>
                      {translate("Activity-date-time")}*
                    </Typography>
                    <CustomDatePickerComponent
                      idRef="activityDateRef"
                      translate={translate}
                      value={
                        state.activityDate ||
                        moment().format("YYYY-MM-DDTHH:mm:ss")
                      }
                      placeholder={"dd/mm/yyyy"}
                      withIcon
                      helperText={
                        getErrorByName(schema, "activityDate").message
                      }
                      isSubmitted={isSubmitted}
                      error={getErrorByName(schema, "activityDate").error}
                      onDateChanged={(newValue) => {
                        const activityDateValue =
                          (newValue &&
                            moment(newValue).format("YYYY-MM-DDTHH:mm:ss")) ||
                          moment()
                            .add(2, "minutes")
                            .format("YYYY-MM-DDTHH:mm:ss");
                        setState({
                          id: "activityDate",
                          value: activityDateValue,
                        });
                        if (activeItem)
                          activityTimeChangeHandler(activityDateValue);
                        if (!activeItem)
                          setState({ id: "activityReminders", value: [] });
                      }}
                      startAdornment={
                        <Calendar
                          width={20}
                          height={20}
                          fill={palette.foreground.quarterary}
                        />
                      }
                      minDate={
                        !activeItem
                          ? moment().format("YYYY-MM-DDTHH:mm:ss")
                          : activeItem?.createdOn
                          ? moment(activeItem.createdOn).format(
                              "YYYY-MM-DDTHH:mm:ss"
                            )
                          : ""
                      }
                      autoOk={translate("Confirm")}
                    />
                    <CustomDatePickerComponent
                      idRef="activityTimeRef"
                      translate={translate}
                      value={
                        state.activityDate ||
                        moment().add(2, "minutes").format("YYYY-MM-DDTHH:mm:ss")
                      }
                      isTimePicker
                      placeholder={"00:00"}
                      withIcon
                      helperText={
                        getErrorByName(schema, "activityDate").message
                      }
                      error={getErrorByName(schema, "activityDate").error}
                      onDateChanged={(newValue) => {
                        setState({
                          id: "activityDate",

                          value:
                            (newValue &&
                              moment(newValue).format("YYYY-MM-DDTHH:mm:ss")) ||
                            null,
                        });

                        if (activeItem)
                          activityTimeChangeHandler(
                            newValue
                              ? moment(newValue).format("YYYY-MM-DDTHH:mm:ss")
                              : null
                          );

                        if (!activeItem)
                          setState({ id: "activityReminders", value: [] });
                      }}
                      minDate={moment().format("YYYY-MM-DDTHH:mm:ss")}
                      startAdornment={
                        <ClockIcon
                          width="20"
                          height="20"
                          fill={palette.foreground.quarterary}
                        />
                      }
                      autoOk={translate("Confirm")}
                    />
                  </Box>
                  <Divider />
                </>
              )}
              {withDateTime && (
                <>
                  <Box className={styles.containerInputFiled}>
                    <Typography className={styles.titleInputFiled}>
                      {translate("Duration")}
                    </Typography>
                    <CustomDatePickerComponent
                      value={selected.durationType}
                      isTimePicker
                      placeholder={"00:00"}
                      onDateChanged={(newValue) => {
                        setSelected({
                          id: "durationType",
                          value:
                            (newValue &&
                              moment(newValue).format("YYYY-MM-DDTHH:mm:ss")) ||
                            null,
                        });
                      }}
                      autoOk={translate("Confirm")}
                      isDisabled={!state.activityDate}
                    />
                  </Box>
                  <Divider />
                </>
              )}
              {isWithReminder && (
                <>
                  <Box className={styles.containerInputFiled}>
                    <>
                      <Box className={styles.containerTitiles}>
                        <Typography className={styles.titleInputFiled}>
                          {translate("Set-reminder")}
                        </Typography>
                        <Typography className={styles.subTitleInputFiled}>
                          {translate("Send-reminder-before")}
                        </Typography>
                      </Box>
                      <Box className={styles.containerSetReminderInputFiled}>
                        <Box>
                          <ReminderTypeOptionsComponent
                            data={
                              selected?.reminderTypeOptions?.agent ||
                              selected?.reminderTypeOptions?.lead ||
                              []
                            }
                            value={
                              selected?.activityReminders?.[0]?.reminderType ||
                              null
                            }
                            valueInput="key"
                            onSelectChanged={(value) => {
                              setState({
                                id: "activityReminders",
                                value: state.activityReminders.map(
                                  (reminder, index) =>
                                    index === 0
                                      ? { ...reminder, reminderType: +value }
                                      : reminder
                                ),
                              });
                              setSelected({
                                id: "activityReminders",
                                value: selected.activityReminders.map(
                                  (reminder, index) =>
                                    index === 0
                                      ? { ...reminder, reminderType: value }
                                      : reminder
                                ),
                              });
                            }}
                          />
                        </Box>
                        <CustomDatePickerComponent
                          value={
                            state.activityReminders[0]?.reminderTime
                              ? String(state.activityReminders[0]?.reminderTime)
                              : null
                          }
                          isTimePicker
                          placeholder={"00:00"}
                          withIcon
                          onDateChanged={(newValue) => {
                            const timeSelected =
                              (newValue &&
                                moment(newValue).format(
                                  "YYYY-MM-DDTHH:mm:ss"
                                )) ||
                              null;
                            setState({
                              id: "activityReminders",
                              value: state.activityReminders.map(
                                (reminder, index) =>
                                  index === 0
                                    ? {
                                        ...reminder,
                                        reminderTime: timeSelected,
                                      }
                                    : reminder
                              ),
                            });
                          }}
                          startAdornment={
                            <ClockIcon
                              width="20"
                              height="20"
                              fill={palette.button.secondary_fg}
                            />
                          }
                          autoOk={translate("Confirm")}
                        />
                        <CustomAutocomplete
                          placeholder={translate("Select-reminder-title")}
                          options={data.reminderTemplates || []}
                          value={
                            selected?.activityReminders?.[0]?.templete?.[0] ||
                            ""
                          }
                          onChange={(e, value) => {
                            setSelected({
                              id: "templete",
                              value: [value],
                            });
                            setState({
                              id: "activityReminders",
                              value: state.activityReminders.map(
                                (reminder, index) =>
                                  index === 0
                                    ? {
                                        ...reminder,
                                        templateId: value.templateId,
                                      }
                                    : reminder
                              ),
                            });
                            setSelected({
                              id: "activityReminders",
                              value: selected.activityReminders.map(
                                (reminder, index) =>
                                  index === 0
                                    ? {
                                        ...reminder,
                                        templete: [value],
                                      }
                                    : reminder
                              ),
                            });
                          }}
                          getOptionLabel={(option) =>
                            (option && option.templateName) || ""
                          }
                          getOptionValue={(option) =>
                            (option && option.templateId) || ""
                          }
                          renderOption={(option) => option?.templateName || ""}
                        />
                        <CustomSelect
                          placeholder={translate("Reminder-for-whom")}
                          style={{ width: "100%" }}
                          options={
                            activityAssignToOptions?.filter(
                              (option) => option?.id && option?.value
                            ) || []
                          }
                          defaultValue={selectedReminderForWhom}
                          getOptionLabel={(option) => option.value}
                          getOptionValue={(option) => option.id}
                          // emptyItem={{ id: 0, name: "Select", isDisabled: true }}
                          onValueChange={(selectedValues) => {
                            setSelectedReminderForWhom(selectedValues);
                            if (!selectedValues) return;
                            const selectedOption =
                              activityAssignToOptions?.find(
                                (option) => option.id === selectedValues
                              ) || null;
                            setState({
                              id: "activityReminders",
                              value: state?.activityReminders.map(
                                (reminder, index) =>
                                  index === 0
                                    ? {
                                        ...reminder,
                                        usersId: selectedValues,
                                      }
                                    : reminder
                              ),
                            });
                            setSelected({
                              id: "activityReminders",
                              value: selected?.activityReminders.map(
                                (reminder, index) =>
                                  index === 0
                                    ? {
                                        ...reminder,
                                        ReminderforWhom: [selectedOption],
                                      }
                                    : reminder
                              ),
                            });
                          }}
                        />
                        <Box className={styles.containerAddReminders}>
                          <CustomButton
                            size="sm"
                            variant="text"
                            color="tertiaryGray"
                            style={{ display: "flex", gap: "12px" }}
                            startIcon={
                              <PlusIcon
                                width="20"
                                height="20"
                                fill={palette.foreground.quarterary}
                              />
                            }
                            onClick={() => {
                              handleAddRemenders();
                            }}
                            disabled={
                              !selected?.activityReminders?.[0]?.templete[0] ||
                              selected?.activityReminders?.[0]?.templete[0]
                                ?.templateName === "" ||
                              selected?.activityReminders?.[0]
                                ?.ReminderforWhom[0]?.value === "" ||
                              !selected?.activityReminders?.[0]
                                ?.ReminderforWhom?.[0] ||
                              !state.activityReminders?.[0]?.reminderTime ||
                              !selected.activityReminders?.[0]?.reminderType
                            }
                          >
                            {translate("Add-Reminders")}
                          </CustomButton>
                        </Box>
                      </Box>
                    </>
                  </Box>
                  <Table className={styles.containerTableReminder}>
                    {state.activityReminders.length > 1 && (
                      <>
                        <thead>
                          <tr className={styles.containerTableHeader}>
                            <th
                              className={clsx(
                                styles.containerTitleHeader,
                                styles.typeTitleReminderStyles
                              )}
                            >
                              {translate("For")}
                            </th>
                            <th
                              className={clsx(
                                styles.containerTitleHeader,
                                styles.typeTitleReminderStyles
                              )}
                            >
                              {translate("Type")}
                            </th>
                            <th
                              className={clsx(
                                styles.containerRimenderTitleHeader,
                                styles.typeTitleReminderStyles
                              )}
                            >
                              {translate("Reminder-title")}
                            </th>
                            <th
                              className={clsx(
                                styles.containerTitleHeader,
                                styles.typeTitleReminderStyles
                              )}
                            >
                              {translate("Duration")}
                            </th>
                            <th
                              className={clsx(
                                styles.containerTitleHeader,
                                styles.typeTitleReminderStyles
                              )}
                            >
                              {translate("Action")}
                            </th>
                          </tr>
                        </thead>

                        <tbody className={styles.containerTableBody}>
                          {state?.activityReminders
                            .slice(1)
                            .map((ItemReminder, index) => (
                              <tr
                                key={index}
                                className={styles.containerTableRow}
                              >
                                {/* For */}
                                <td
                                  className={clsx(
                                    styles.forValue,
                                    styles.timeReminderForPersonStyles
                                  )}
                                >
                                  {selected?.activityReminders
                                    ?.flatMap(
                                      (reminder) => reminder.ReminderforWhom
                                    )
                                    ?.find(
                                      (option) =>
                                        option?.id === ItemReminder.usersId ||
                                        option?.id === ItemReminder.leadId
                                    )?.value || null}
                                </td>

                                {/* Type */}
                                <td
                                  className={clsx(
                                    styles.forValue,
                                    styles.typeTitleReminderStyles
                                  )}
                                >
                                  {selected?.reminderTypeOptions?.agent?.find(
                                    (option) =>
                                      option?.key === ItemReminder?.reminderType
                                  )?.value ||
                                    selected?.reminderTypeOptions?.lead?.find(
                                      (option) =>
                                        option?.key ===
                                        ItemReminder?.reminderType
                                    )?.value ||
                                    null}
                                </td>

                                {/* Reminder Title */}
                                <td
                                  className={clsx(
                                    styles.reminderValue,
                                    styles.typeTitleReminderStyles
                                  )}
                                >
                                  {selected?.activityReminders
                                    ?.flatMap((reminder) => reminder.templete)
                                    ?.find(
                                      (option) =>
                                        option?.templateId ===
                                        ItemReminder?.templateId
                                    )?.templateName || null}
                                </td>

                                {/* Duration */}
                                <td
                                  className={clsx(
                                    styles.forValue,
                                    styles.timeReminderForPersonStyles
                                  )}
                                >
                                  {ItemReminder?.reminderTime &&
                                  ItemReminder?.reminderTime.trim() !== ""
                                    ? formattedTimeFun(
                                        new Date(ItemReminder?.reminderTime)
                                      )
                                    : ""}
                                </td>

                                {/* Action */}
                                <td className={styles.containerActionButton}>
                                  <Box
                                    className={styles.containerIconActionButton}
                                  >
                                    <DeleteIcon
                                      width="20"
                                      height="20"
                                      fill={palette.button.tertiaryGray_fg}
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleDeleteLink(index + 1)
                                      }
                                    />
                                  </Box>
                                  <Box
                                    className={styles.containerIconActionButton}
                                  >
                                    <EditIcon
                                      width="20"
                                      height="20"
                                      fill={palette.button.tertiaryGray_fg}
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleEditLink(ItemReminder?.index)
                                      }
                                    />
                                  </Box>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </>
                    )}
                  </Table>
                </>
              )}

              <Box className={styles.containerMoreOption}>
                <Typography>
                  {isExpanded ? (
                    <Typography className={styles.MoreOptionTitle}>
                      {translate("View-less-options")}
                    </Typography>
                  ) : (
                    <Typography className={styles.MoreOptionTitle}>
                      {translate("View-more-options")}
                    </Typography>
                  )}
                </Typography>
                <DropdownIcon
                  width="20"
                  height="20"
                  fill={
                    palette.foreground.navigation["nav-item-button-icon-fg"]
                  }
                  onClick={handleExpandMoreOptions}
                  style={{
                    transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
              </Box>
              {isExpanded && (
                <Box className={styles.containerMoreOptionDetails}>
                  <Box className={styles.containerSwitchAndTitle}>
                    <CustomSwitch
                      size={"md"}
                      checked={state.isOpen}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setState({ id: "isOpen", value: isChecked });
                      }}
                      isDisabled={false}
                    />
                    <Box className={styles.containerTitles}>
                      <Typography>
                        {state.isOpen ? translate("open") : translate("closed")}
                      </Typography>
                      {state.isOpen ? (
                        <Typography className={styles.statusTitle}>
                          {translate("I-am-open-and-avaliable")}
                        </Typography>
                      ) : (
                        <Typography className={styles.statusTitle}>
                          {translate("I-am-close-and-not-avaliable")}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <Divider />
                  <Box className={styles.containerInputFiled}>
                    <Typography className={styles.titleInputFiled}>
                      {translate("Attachment")}
                    </Typography>
                    <DropzoneComponent
                      title={translate("SVG-PNG-JPG-or-GIF-max-800x400px")}
                      setUploadedFileId={setUploadedFileId}
                      onFilesAccepted={handleFilesAccepted}
                    />
                  </Box>
                  <Box className={styles.containerInputFiled}>
                    <Typography className={styles.titleInputFiled}>
                      {translate("Comment")}
                    </Typography>
                    <CustomTextArea
                      maxRows={5}
                      minRows={5}
                      placeholder={translate("Enter-a-comments")}
                      onInputChange={(value) => {
                        setState({ id: "comments", value: value });
                      }}
                      value={state?.comments || ""}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        }
      />
    </>
  );
}

export default ReplayActivityFormDialog;
